import axios from 'axios';

import { TENANT } from 'constants/misc';
import {
  LOCAL_ENVIRONMENT_HEADER,
  showLocalEnvironmentBadge
} from 'utils/localEnvironmentBadge';

const LOCAL = import.meta.env.VITE_BASE_URL || '';
const isProd = import.meta.env.MODE === 'production';

export const BASE_URL = (isProd ? '' : LOCAL).replace('#{tenantName}', TENANT);

let requestInterceptorId: number | null = null;
let responseInterceptorId: number | null = null;

export const setupAxios = () => {
  // Each time setupAxios() is called (route change dojo and HMR) it
  // first ejects the previously registered
  // interceptors (using the stored IDs) before registering fresh ones.
  // This ensures there's always exactly one request interceptor and one
  // response interceptor active, regardless of how many HMR cycles occur.
  if (requestInterceptorId !== null) {
    axios.interceptors.request.eject(requestInterceptorId);
  }
  if (responseInterceptorId !== null) {
    axios.interceptors.response.eject(responseInterceptorId);
  }

  requestInterceptorId = axios.interceptors.request.use((config) => {
    if (!config.url?.startsWith('./')) {
      const username: any = sessionStorage.getItem('principal');
      let newURL = config.url?.replace('{username}', username);

      Object.entries(config.pathParams || {})
        .filter((entries) => entries[1])
        .forEach(([key, value]) => {
          newURL = newURL?.replace(`:${key}`, encodeURIComponent(value));
        });

      if (newURL?.[0] === '/') {
        //TODO: remove this when secure is removed from endpoints
        config.url = `${BASE_URL}${newURL}`;
      } else {
        config.url = `${BASE_URL}/${newURL}`;
      }
    }

    const headers = config.headers || {};
    headers.Authorization = `Bearer ${sessionStorage.getItem('accessToken')}`;
    config.headers = headers;
    return config;
  });

  responseInterceptorId = axios.interceptors.response.use(
    (response) => {
      // Only ever present on a locally run stack; see utils/localEnvironmentBadge.
      showLocalEnvironmentBadge(response.headers?.[LOCAL_ENVIRONMENT_HEADER]);
      return response;
    },
    (error) => {
      // Also on the failure path: a 401 against production is exactly when you want to know which
      // environment you are talking to, and the header rides on every response.
      showLocalEnvironmentBadge(
        error.response?.headers?.[LOCAL_ENVIRONMENT_HEADER]
      );

      if (error.response.status === 401) {
        window._logoutDojo?.();
      }

      return Promise.reject(error);
    }
  );
};
